import { render, staticRenderFns } from "./TyreAlert.vue?vue&type=template&id=bb5960b0"
import script from "./TyreAlert.vue?vue&type=script&lang=js"
export * from "./TyreAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports